<mat-toolbar color="primary">
  <span>blankmile admin dashboard</span>
  <span class="spacer"></span>
  <button mat-button aria-label="Logout" (click)="onLogoutClicked()">
    Logout
  </button>
</mat-toolbar>
